module.exports = __webpack_public_path__ + "img/53.77ca7cb1.png";